<template>
  <section class="viewsrhqyClockManage_ClockList space-y-4 p-4">
    <viewTitle
      title="业务管理 / 发货打卡管理 / 发货打卡记录"
      :showReturn="true"
    >
      <template slot="return">
        <el-button
          @click="onPushSap"
          type="primary"
          v-has="['c-clock-record-pushSap']"
          size="small"
        >
          确认上传SAP
        </el-button>
        <el-button
          v-has="['c-clock-record-export']"
          @click="onExport"
          size="small"
        >
          导出excel
        </el-button>
      </template>
    </viewTitle>
    <el-form
      :inline="true"
      :model="queryParam"
      class="search-form-inline-small"
    >
      <el-form-item label="账号">
        <el-input
          clearable
          v-model="queryParam.account"
          placeholder="请输入账号"
          class="w-36"
        ></el-input>
      </el-form-item>
      <el-form-item label="供应商编号">
        <el-input
          clearable
          v-model="queryParam.supplier_code"
          placeholder="请输入供应商编号"
          class="w-44"
        ></el-input>
      </el-form-item>
      <el-form-item label="供应商名称">
        <el-input
          clearable
          v-model="queryParam.supplier_name"
          placeholder="请输入供应商名称"
          class="w-44"
        ></el-input>
      </el-form-item>
      <el-form-item label="木片厂名">
        <el-input
          clearable
          v-model="queryParam.chip_name"
          placeholder="请输入木片厂名"
          class="w-44"
        ></el-input>
      </el-form-item>
      <el-form-item label="送货单号">
        <el-input
          clearable
          v-model="queryParam.deliver_code"
          placeholder="请输入送货单号"
          class="w-44"
        ></el-input>
      </el-form-item>
      <el-form-item label="车头车牌号">
        <el-input
          clearable
          v-model="queryParam.license_plate"
          placeholder="请输入车头车牌号"
          class="w-44"
        ></el-input>
      </el-form-item>
      <el-form-item label="基地" v-if="baseInfo.is_main_com === 1">
        <el-select
          placeholder="请选择基地"
          class="w-40"
          clearable
          v-model="queryParam.delivery_com_id"
        >
          <el-option
            v-for="item in com_list"
            :key="item.com_id"
            :label="item.com_name"
            :value="item.com_id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="打卡时间">
        <el-date-picker
          class="!w-96"
          v-model="timeRange"
          type="datetimerange"
          align="right"
          unlink-panels
          range-separator="至"
          :default-time="['00:00:00', '23:59:59']"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
          value-format="timestamp"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-checkbox
          :true-label="1"
          :false-label="0"
          v-model="queryParam.show_delete"
          >显示已删除记录</el-checkbox
        >
      </el-form-item>
      <el-form-item>
        <el-button
          @click="onRefreshData"
          type="primary"
          size="small"
          >刷新数据</el-button
        >
        <el-button
          @click="onReset"
          size="small"
          >重置</el-button
        >
      </el-form-item>
    </el-form>
    <c-table
      class="mt-4"
      :isIndex="false"
      :isSelection="true"
      :selection.sync="rowKeySelection"
      :data="dataSource"
      :columns="columns"
      :query.sync="pagintion"
      :total="total"
      row-key="id"
      @loadPage="loadData"
    >
      <template slot="clock_day" slot-scope="{ row }">
        {{ row.clock_time | timeFormat("YYYY-MM-DD") }}
      </template>
      <template slot="clock_time" slot-scope="{ row }">
        {{ row.clock_time | timeFormat("HH:mm:ss") }}
      </template>
      <template slot="action" slot-scope="{ row }">
        <div class="space-x-4">
          <c-link
            v-has="['c-clock-record-detail']"
            @click="onView(row)"
            type="primary"
            label="查看"
          ></c-link>
          <c-link
            v-has="['c-clock-record-update']"
            v-if="row.info_state == 1"
            @click="onEdit(row)"
            type="success"
            label="修改"
          ></c-link>
          <c-link
            v-if="row.info_state == 1"
            v-has="['c-clock-record-delete']"
            @click="onDelete(row, true)"
            type="danger"
            label="删除"
          ></c-link>
        </div>
      </template>
    </c-table>
  </section>
</template>

<script>
import initListMinxin from "@/mixins/jl/initListMinxin";
import mixinTableLyout from "@/views/rhqy/config/mixinTableLyout.js";
import { mapGetters } from "vuex";
import moment from "moment";
export default {
  props: [],

  data() {
    return {
      // 关键步骤：拆分 PC 发货打卡记录复合 keyword，避免一个输入框触发多字段 OR 模糊查询。
      queryParam: {
        account: "",
        supplier_code: "",
        supplier_name: "",
        chip_name: "",
        deliver_code: "",
        license_plate: ""
      },
      // 关键步骤：恢复页面级自动查询开关，让查询条件修改后直接复用 mixin 的防抖查询逻辑。
      autoSearch: true,
      // 关键步骤：初始化默认筛选条件时先由页面接管首屏查询，避免 mixin 和监听器叠加触发重复请求。
      disabledCreated: true,
      columns: [
        { label: "账号", prop: "account" },
        { label: "供应商编号", prop: "supplier_code" },
        { label: "供应商名称", prop: "supplier_name" },
        { label: "木片厂名", prop: "chip_name" },
        { label: "送货单号", prop: "deliver_code" },
        {
          label: "送货基地",
          prop: "delivery_com_name"
        },
        { label: "车头车牌号", prop: "license_plate" },
        { label: "打卡日期", prop: "clock_day" },
        { label: "打卡时间", prop: "clock_time" },
        {
          label: "传输SAP",
          prop: "is_push_sap",
          formatData: row => (row.is_push_sap == 1 ? "是" : "否")
        },
        { label: "操作", prop: "action" }
      ],
      deleteConfig: {
        url: "/api/queue/admin/delete_booking_clock"
      },
      exportDataEvent: params => {
        return this.$common.http({
          url: "/api/queue/admin/export_booking_clock",
          data: params,
          noLoading: true
        });
      },
      fetchDataEvent: params =>
        this.$common.http({
          url: "/api/queue/admin/query_booking_clock",
          data: params
        })
    };
  },

  computed: {
    ...mapGetters(["baseInfo"])
  },

  components: {},

  mixins: [initListMinxin, mixinTableLyout],

  beforeCreate() {},

  created() {
    // 关键步骤：初始化默认筛选条件时临时关闭自动查询，避免 queryParam 和 timeRange 赋值阶段重复触发列表请求。
    this.applyDefaultFilters({ triggerSearch: true });
  },

  beforeMount() {},

  mounted() {},

  activated() {},

  deactivated() {},

  methods: {
    // 生成默认查询条件，首屏和重置都限制在最近 7 天内，避免误触发全量查询。
    getDefaultQueryParam() {
      const beginTime = moment()
        .startOf("days")
        .subtract("7", "days");
      const endTime = moment().endOf("days");

      return {
        account: "",
        supplier_code: "",
        supplier_name: "",
        chip_name: "",
        deliver_code: "",
        license_plate: "",
        delivery_com_id: "",
        show_delete: 0,
        begin_time: beginTime.format("X"),
        end_time: endTime.format("X")
      };
    },
    // 初始化和重置时统一回填默认筛选条件，并按需触发一次查询。
    applyDefaultFilters({ triggerSearch = false } = {}) {
      const defaultQueryParam = this.getDefaultQueryParam();
      const previousAutoSearch = this.autoSearch;

      this.autoSearch = false;
      this.queryParam = defaultQueryParam;
      this.timeRange = [
        moment.unix(defaultQueryParam.begin_time).valueOf(),
        moment.unix(defaultQueryParam.end_time).valueOf()
      ];
      this.autoSearch = previousAutoSearch;

      if (triggerSearch) {
        this.onSearch();
      }
    },
    // 重置筛选条件时恢复默认时间窗口，避免清空时间后形成大范围查询。
    onReset() {
      this.pagintion.page = 1;
      this.applyDefaultFilters({ triggerSearch: true });
    },
    // 统一筛选触发入口，避免页面同时出现“查询”和“刷新数据”两个等价按钮。
    onRefreshData() {
      this.onSearch();
    },
    // 查看打卡详情。
    onView(row) {
      this.$router.push({
        path: "/rhqy/service/clockIn/ClockDetail/view/" + row.id
      });
    },
    // 修改打卡记录。
    onEdit(row) {
      this.$router.push({
        path: "/rhqy/service/clockIn/ClockDetail/edit/" + row.id
      });
    },
    // 批量确认上传 SAP，逐条调用后端接口以复用既有单条上传逻辑。
    onPushSap() {
      if (this.rowKeySelection.length === 0) {
        this.$message({ message: "请选择要上传SAP的记录！", type: "warning" });
        return;
      }
      this.$confirm(
        `确认上传已选中的${this.rowKeySelection.length + "条"}记录？`,
        "提示"
      ).then(async _ => {
        try {
          let that = this;
          async function handler() {
            const id = that.rowKeySelection[0];
            await that.$common.http({
              url: "/api/queue/admin/push_booking_clock",
              data: { id }
            });
            that.rowKeySelection.splice(0, 1);
            if (that.rowKeySelection.length === 0) {
              this.$message.success("操作成功");
            } else {
              handler();
            }
          }
          handler();
        } catch (error) {
          console.log("error", error);
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
@import "../assets/css/common";
</style>


